
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 18","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.134 2.892v3.247L3.323 4.513zm1.71 2.47h1.687c3.13 0 6.262 0 9.393.002h.018c.157 0 .32 0 .453.043l.04.013c.414.13.842.266 1.236.449.421.195.753.396 1.014.613.6.502.997.986 1.247 1.525.203.437.412.89.511 1.35.075.345.091.715.107 1.073.008.161.015.328.028.493.002.034.007.067.012.1l.022.165h1.548l.012-.132c.085-1.001-.01-1.897-.29-2.738-.29-.866-.678-1.564-1.187-2.133-.324-.362-.705-.776-1.133-1.117a6.393 6.393 0 00-2.174-1.112 7.2 7.2 0 00-2.042-.285c-2.568-.004-5.179-.003-7.704-.003H7.84V0l-.215.123A683.49 683.49 0 003.71 2.374c-1.139.66-2.317 1.34-3.493 2.013L0 4.51l7.844 4.53z"}}),_c('path',{attrs:{"d":"M22.697 13.496l-2.844 1.643v-3.28zm3.31 0l-7.813-4.513v3.681h-.589l-2.827-.01c-2.59-.01-5.182-.02-7.773-.028-.465-.001-.907-.153-1.285-.295a4.685 4.685 0 01-1.505-.909c-.474-.428-.784-.797-1.007-1.197-.106-.19-.2-.396-.29-.594l-.079-.172a3.59 3.59 0 01-.342-1.396l-.008-.235c-.007-.246-.015-.5-.032-.751-.01-.125-.154-.266-.277-.27a30.626 30.626 0 00-.936-.006H.788l.01.153c.012.194.015.388.019.576.007.38.015.773.094 1.166.114.569.226 1.079.44 1.568.25.577.571 1.102.953 1.559.596.714 1.234 1.25 1.95 1.639.473.256.982.515 1.549.623.116.022.233.047.35.073.339.073.689.149 1.04.15 2.776.014 5.598.013 8.326.012l2.559-.001h.129V18z"}})])
          )
        }
      }
    